import { ProductType } from '@features/product/components/Collection/Collection.types';
import { useTranslation } from '@i18n/useTranslation';

export const useGetCollectionTitle = (
  title: string,
  productType?: ProductType | null,
  isEntranceTitle = false
) => {
  const { t } = useTranslation('webshop.productPage');

  if (title) {
    return isEntranceTitle ? `${title}:` : title;
  }

  if (productType && productType.singularName) {
    const collectionTitle = t('collection.collectionTitleFallback', {
      productTypeName: productType.singularName
    });

    return isEntranceTitle ? `${collectionTitle}:` : collectionTitle;
  }

  return '';
};
